const AbortC = typeof AbortController !== "undefined" ? AbortController : class {
    signal: undefined = undefined
    abort() { }
};
type AbortC = typeof AbortC;
/** Idenfificador de petición */
type AbortTAG = string | number;

/**
 * Extiende el Native AbortController y proporciona funcionalidad adicional para abortar las solicitudes.
 */
export class DataUtilAbortController extends AbortC {
    private tag: AbortTAG;
    private isAborted = false;
    // private isCompleted = false;

    private static abortWaiters: Set<RAbortController> = new Set();
    /**
     * Construye una nueva instancia de DataUtIlRequestAbortController.
     *
     * @param tag - Identificador para la solicitud (o solicitudes vinculadas).
     */
    constructor(tag?: AbortTAG) {
        super();
        this.tag = tag;
        RAbortController.abortWaiters.add(this);
    }

    abort(reason?: unknown): void {
        if (this.isAborted) return;
        this.isAborted = true
        super.abort(reason);
        RAbortController.RemoveAbortItem(this);
    }

    /**
     * Obtiene la etiqueta asociada con la solicitud.
     *
     * @returns {AbortTAG}
     */
    get _Tag() { return this.tag; }

    /**
     * Obtiene un valor que indica si la solicitud ha sido abortada.
     */
    get _Aborted() { return this.isAborted; }


    // **********************************************************************************
    // STATIC FUNCTIONS
    // **********************************************************************************

    /**
    * Elimina la instancia especificada de 'AbortController` de la matriz' Abortwaiters`.
    *
    * @param item - The `AbortController` instance to remove.
    *
    * @returns void
    */
    private static RemoveAbortItem(item: RAbortController) {
        this.abortWaiters.delete(item);
        // const i = this.abortWaiters.indexOf(item);
        // if (i > -1) this.abortWaiters.splice(i, 1);
    }

    /**
    * Aborta todas las instancias de `abortcontroller` con el mismo TAG.
    *
    * @param tag: la etiqueta de las solicitudes para abortar.
    *
    * @returns void
    */
    public static _AbortByTag(tag: string, ignore?: RAbortController[]) {
        Array.from(this.abortWaiters.values())
            .filter(a => a._Tag === tag && (!ignore || !ignore.includes(a)))
            .forEach(a => a.abort());
    }

    /**
     * Cancela la instancia especificada de 'AbortController'.
     *
     * @param item
     *
     * @returns this
     */
    public static _RemoveAbortItem(item: RAbortController) {
        this.RemoveAbortItem(item);
        return this;
    }

    /**
     * Cancela todas las instancias de 'AbortController' con la etiqueta especificada.
     *
     * @param tag - La etiqueta de las solicitudes para cancelar.
     *
     * @returns this
     */
    public static _RemoveAbortItemsByTag(tag: AbortTAG) {
        this.abortWaiters.forEach(a => {
            if (a._Tag != tag) return
            this.RemoveAbortItem(a)
        });
        return this;
    }

    /**
     * Cancela todas las instancias de `abortcontroller`.
     *
     * @returns void
     */
    public static _RemoveAllAbortItems() {
        this.abortWaiters.clear();
    }
}

const RAbortController = DataUtilAbortController
type RAbortController = DataUtilAbortController